import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../reducers';
import { currentUser } from '../auth';
import { environment } from '../../../environments/environment';
import { HttpUtilsService } from '../_base/crud';
import { Blocker } from '../models';
import { TemplateType, TransactionType } from '../enums';

const API_BASE = environment.TRACKER_BASE;

@Injectable({ providedIn: 'root' })
export class BlockerService {
  private companyId;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.select(currentUser).subscribe((user) => {
      this.companyId = user.userType === 'Super Admin' ? 0 : user.companyID;
    });
  }

  createUpdateBlockers(
    templateId: number,
    templateType: TemplateType,
    blockers: Partial<Blocker>[],
  ): Observable<Blocker[]> {
    return this.http.put<Blocker[]>(
      `${API_BASE}/companies/${this.companyId}/blockers/templates/${templateId}?template_type=${templateType}`,
      {
        blockers,
      },
    );
  }

  getBlockers(templateId: number, templateType: TemplateType): Observable<Blocker[]> {
    return this.http.get<Blocker[]>(
      `${API_BASE}/companies/${this.companyId}/blockers/templates/${templateId}?template_type=${templateType}`,
    );
  }

  createUpdateTransactionBlockers(
    transactionId: number,
    transactionType: TransactionType,
    blockers: Partial<Blocker>[],
  ): Observable<Blocker[]> {
    return this.http.put<Blocker[]>(
      `${API_BASE}/companies/${this.companyId}/blockers/transactions/${transactionId}?transaction_type=${transactionType}`,
      { blockers },
    );
  }

  postPutBlockersTemplate(blockers, template_id) {
    return this.http.put<Blocker[]>(
      `${API_BASE}/companies/${this.companyId}/blockers/templates/${template_id}?template_type=TASK_TEMPLATE`,
      blockers,
    );
  }
}
